import React, { Component } from 'react';

class NombreArchivo extends Component {
    constructor(props) {
        super(props);
    }

    handleChangeNombreArchivo = (e) => {
        let result = e.target.value == " " ? false : true;
        if (!result) {
            e.preventDefault();
        }else {
            this.props.setNombreArchivo(e.target.value);
        }
    }

    onClickFunction(event) {
        let result = event.key == " " ? false : true;
        if (!result) {
            event.preventDefault();
        } 
    }

    render() {
        const { archivoAsociado } = this.props;  

        return (
            <div className='row top-separator-xs'>
                <div className="form-group top-separator-xs bottom-separator-xs marignLeft-15px">
                    <div className="col-md-12 no-padding-left">
                        <label className="label-primary">Nombre del archivo</label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-5 marignLeft-15px">
                        <input
                            onChange={this.handleChangeNombreArchivo}
                            onKeyPress={this.onClickFunction}
                            id="nombreArchivo"
                            value={archivoAsociado?.nombreArchivoUsuario}
                            name="nombreArchivo"
                            placeholder="Ingrese el nombre del archivo"
                            className="form-control form-control-tarjetas"
                            maxLength={100}
                        />
                        {archivoAsociado.errorNombreArchivo && <label className="error">Ingrese el nombre para el archivo</label>}
                    </div>
                </div>
            </div>
        )
    };
}

export default NombreArchivo;
